const AlphaFoundationsThemes = {
    alpha_50: '0',
    alpha_100: '0.1',
    alpha_150: '0.2',
    alpha_200: '0.3',
    alpha_250: '0.4',
    alpha_300: '0.5',
    alpha_350: '0.6',
    alpha_400: '0.7',
    alpha_450: '0.8',
    alpha_500: '0.9',
    alpha_550: '1',
};
export { AlphaFoundationsThemes };
//# sourceMappingURL=alpha-foundations.themes.js.map